import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider8',
  templateUrl: './revolution-slider8.component.html'
})
export class RevolutionSlider8Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
